export const templateOfVideoBlock = `
    <div class="row content-block">
        <div class="col-12 column px-8 py-4">
            <div class="video-wrapper">
                <iframe src="https://www.youtube.com/embed/U7nOMjJW86M" frameborder="0" allowfullscreen tag="external-video"></iframe>
            </div>
        </div>
    </div>
`
